export default "__VITE_ASSET__C$I9qZAx__"